<template>
  <v-progress-linear
      :value="localPourcent"
      height="20"
      :color="AppStore.data.general.primary_color.hexa"
  ><span id="progress-pourcent" style="color:white; font-weight: bold">{{ Math.ceil(localPourcent) >= 100 ? $t('component.stepper_completed') : Math.ceil(localPourcent) + '%' }}</span>
  </v-progress-linear>
  
</template>

<script>

import AppStore from "../../stores/AppStore";
import _ from "lodash";

export default {
  name: 'stepper',

  components: {},

  props: {},

  data: () => ({
    AppStore,
  }),

  created() {
  },

  mounted() {

  },

  computed: {
    localPourcent() {
      const config = _.get(this.AppStore, 'data.configuration', {});
      const questionsByPage = _.get(this.AppStore, 'questions_by_page', []);

      const pages = [
        {
          route: 'tb-3-home',
          enabled: true
        },
        {
          route: 'tb-3-appreciation',
          enabled: !config.skip_appreciation_page
        },
        {
          route: 'tb-3-comment',
          enabled: true
        },
        {
          route: 'tb-3-questions',
          enabled: !config.skip_questions_page
        },
        // {
        //   route: 'tb-3-timeline',
        //   enabled: true
        // }
      ];

      const activePages = pages.filter(p => p.enabled);
      const currentIndex = activePages.findIndex(p => p.route === this.$route.name);

      // Percentage per page
      return ((currentIndex) / activePages.length) * 100;
    }
  },

  watch: {

  },

  methods: {}
};
</script>
<style>

</style>